import styled from '@emotion/styled';
import { breakpoints } from '~/theme/breakpoints';

export const SectionTitle = styled.h4(({ theme }) => ({
    ...theme.mixins.useTextStyle('sectionLabel'),
    color: theme.colors.black,
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: `${theme.space[3]}`,

    [breakpoints.sm]: {
        padding: `${theme.space[3]}`,
        borderTop: `1px solid ${theme.colors.brownLight}`,
        borderBottom: `1px solid ${theme.colors.brownLight}`,
    },
}));
